import { render, staticRenderFns } from "./SettingsManage.vue?vue&type=template&id=62cb0e28&scoped=true"
import script from "./SettingsManage.vue?vue&type=script&lang=js"
export * from "./SettingsManage.vue?vue&type=script&lang=js"
import style0 from "./SettingsManage.vue?vue&type=style&index=0&id=62cb0e28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cb0e28",
  null
  
)

export default component.exports